// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Dmsr","content":"RecentSearches_content__1xKdj"};